<template>
  <div>
    <div v-if="showButton" class="bg-white p-3 row flex- justify-content-between">
      <div class="col d-flex align-items-center">
        <button class="btn-close-custom bg-light border-0" @click="dismiss">
        </button>
  <!--      {{this.$store.getters.title}}-->
      </div>
      <div class="col-9 d-flex justify-content-end">
        <button @click="installApp" class="bg-install rounded border-0 py-2 px-3 fw-semibold">
          {{ this.$store.getters.installButton.text }}
        </button>
      </div>
    </div>

    <div v-if="isIosModalVisible && showButton" class="ios-modal">
      <div class="ios-modal-content">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h2 class="m-0 me-3">Installation auf iOS</h2>
          <button class="btn-close-custom bg-light border-0" @click="dismiss"></button>
        </div>
        <p class="m-0">Tippe auf «…» und Teilen:</p>
        <div class="ios-step-icons">
          <span class="ios-ellipsis" aria-hidden="true">…</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16"><path d="M11 7V6h3v9H3V6h3v1H4v7h9V7zM6.74 4 8 2.739V11h1V2.705L10.295 4l.324.324.707-.707L8.517.807l-2.809 2.81.707.707z"/><path fill="none" d="M0 0h16v16H0z"/></svg>
        </div>
        <p class="mt-2 m-0">Dann «Zum Home-Bildschirm»:</p>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><g stroke="#212529" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M8 12h8M12 16V8M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7z"/></g></svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pep-install',
  data() {
    return {
      showButton: false,
      deferredPrompt: null,
      userChoice: null,
      isIosModalVisible: false,
    };
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', this.handleAppInstalled);
  },
  beforeUnmount() {
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
    window.removeEventListener('appinstalled', this.handleAppInstalled);
  },
  methods: {
    handleBeforeInstallPrompt(event) {
      event.preventDefault();
      setTimeout(() => {
        if (this.userChoice !== 'dismissed') {
          this.showButton = true;
        }
        this.deferredPrompt = event;
      }, 3000);
    },
    handleAppInstalled() {
      this.showButton = false;
      this.deferredPrompt = null;
      this.userChoice = 'installed';
    },
    installApp() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then((choiceResult) => {
          this.userChoice = choiceResult.outcome;
          this.deferredPrompt = null;
          this.showButton = false;
        });
      } else {
        this.isIosModalVisible = true;
        // this.showIosInstallInstructions();
      }
    },
    dismiss() {
      this.showButton = false;
      this.deferredPrompt = null;
      this.userChoice = 'dismissed';
    },
    handleLoad() {
      setTimeout(() => {
        if (this.isIos && this.userChoice !== 'installed' && this.userChoice !== 'dismissed') {
          this.showButton = true;
        }
      }, 3000);

      if (this.userChoice === 'installed') {
        this.showButton = false;
      } else if (this.userChoice === 'dismissed') {
        this.showButton = false;
      }
    },
  },
  computed: {
    isIos() {
      if(window.navigator.standalone === true) return false;
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isAppleDevice = /iphone|ipad|ipod/.test(userAgent);
      // const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

      // return isAppleDevice || isSafari;
      return isAppleDevice;
    }
  },
  watch: {
    userChoice(newVal) {
      // only set for current page /:ticket
      localStorage.setItem('pwa-install-user-choice-' + this.$store.getters.ticket, newVal);
    },
    // add watcher for this.$store.getters.ticket to reset userChoice
    $store: {
      handler() {
        this.userChoice = localStorage.getItem('pwa-install-user-choice-' + this.$store.getters.ticket);
        this.handleLoad();
      },
      deep: true,
    },

  },
};
</script>

<style lang="scss">
button.btn-close-custom {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  &:before, &:after {
    content: "";
    position: absolute;
    bottom: 9px;
    left: 19px;
    width: 2px;
    height: 20px;
    background: black;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(135deg);
  }
}

.ios-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;

  .ios-modal-content {
    background: white;
    padding: 1rem 1rem 1.25rem;
    border-radius: 10px;
    margin: .5rem;
  }
}

.ios-step-icons {
  display: flex;
  align-items: center;
  gap: .5rem;
  margin-top: .25rem;
}

.ios-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1;
}
</style>